<template>
    <div class="fx-app">
        <div v-if="isFxClient" class="fx-app-header">
          <div class="fx-app-header-title">{{props.title}}</div>
        </div>
        <slot></slot>
    </div>
</template>
  
<script lang="ts">
  export default {
    name: 'FxApp',
  };
</script>
<script setup lang="ts">
  const props = defineProps({
    title: String,
  });
  const isFxClient = window.configWin
</script>
  
<style lang="less">
  .fx-app{
    position:fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .fx-app .fx-app-header{
    height: 40px;
    
    letter-spacing: 0px;
    padding-left: 10px;
    color: #ffffff;
    background: linear-gradient(45deg, #D2B1FF 60%, #5191FF 90%, #4DCDFF 100%);
    
  }
  .fx-app .fx-app-header .fx-app-header-title{
    -webkit-app-region: drag;
    display: inline-block;
    line-height: 40px;
    font-size: 15px;
  }
</style>
  